import { isPending } from 'app/api/redux-util/async-helpers';
import { createSelector } from 'reselect';

const emptyArray = [];

export function createSelectors(name) {
  function getAllData(state) {
    return state.jigsaw[name].entries;
  }

  const getItems = createSelector(
    state => state.jigsaw[name].list.data,
    state => getAllData(state),
    (list, data) =>
      list ? list.items.map(id => data[id]).filter(item => !!item) : emptyArray
  );

  function isProcessing(state, actionName, guid) {
    return state.jigsaw[name].pending[actionName].indexOf(guid) >= 0;
  }

  return {
    getItems,

    getItemData: function(state, guid) {
      return state.jigsaw[name].entries[guid];
    },

    isPending: function(state) {
      return isPending(state.jigsaw[name].list);
    },

    hasItems: function(state) {
      return getItems(state).length > 0;
    },

    isDeleteProcessing: function(state, guid) {
      return isProcessing(state, 'del', guid);
    },

    isUpdateProcessing: function(state, guid) {
      return isProcessing(state, 'update', guid);
    },

    hasError: function(state) {
      return state.jigsaw[name].list.hasError;
    },
  };
}
